<template>
  <div class="register">
    <h1 class="h1">请选择</h1>
    <div class="reg-type">
      <van-radio-group v-model="reg_type">
        <van-radio v-for="(g, index) in grade" :key="index" :name="g.id" class="type-m">
          <p class="p1">{{ g.name }}</p>
          <p class="p1 p2">注册享优惠</p>
        </van-radio>
      </van-radio-group>
    </div>
    <van-button type="default" class="reg-btn" @click="regType">确认</van-button>
  </div>
</template>

<script>
import { Button, RadioGroup, Radio } from 'vant'

export default {
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  name: 'HelloWorld',
  data () {
    return {
      grade: [],
      reg_type: 0
    }
  },
  created() {
    if(this.$route.query.hid){
      localStorage.setItem('hid', this.$route.query.hid)
    }else{
      localStorage.setItem('hid', 0)
    }

    if(!localStorage.getItem('weixin_openid')) {
      let redirectUri = window.location.href
      let code = this.getUrlParam("code")
      if(process.env.NODE_ENV === 'production') {
        // 微信授权登录
        if(!code){
          sessionStorage.setItem('redirectPath', redirectUri)
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + process.env.WX_APPID + "&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
        }
        this.$api.post('socials/wechat/authorizations?code=' + code + '&status=1', null, r=>{
          if (r.success === 1) {
            localStorage.setItem('weixin_openid', r.data.oauth_user.weixin_openid)
            localStorage.setItem('nickname', r.data.oauth_user.nickname)
            localStorage.setItem('avatar', r.data.oauth_user.avatar)
            let redirectPath = sessionStorage.getItem('redirectPath')
            if (redirectPath) {
              sessionStorage.removeItem('redirectPath')
              window.location.href = redirectPath
            }
          }
        })
      }
    }

    if(window.localStorage.getItem('auth')){
      this.$router.push({name:'details.vue'})
      return
    }else{
      this.$api.get('users/grade', null, r=>{
        this.grade = r.data
      })
    }
  },
  methods: {
    regType() {
      if(this.reg_type == 0){
        this.$toast('请选择注册类型')
      }else{
        this.$router.push('/register/genre/'+this.reg_type)
      }
    },
    getUrlParam(name) {
      //name为要获取的参数名
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var rrr = decodeURIComponent(window.location.search);
      var r = rrr.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  }
}
</script>
<style scoped>
  .register{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
  }
  .register .h1{
    text-align: center;
    font-size: 23px;
    font-weight: normal;
    color:#3e3f3f;
    margin: 50px 0 30px;
  }
  .register .reg-type{
    margin: 0 10%;
    height: 200px;
    overflow: hidden;
  }
  .register .reg-type .p1{
    margin:0;
    padding:0;
    text-align: left;
    color:#3e3f3f;
    font-size: 16px;
  }
  .register .reg-type .p2{
    color:#969799;
    font-size: 14px;
    margin-top:5px;
  }
  .type-m{
    border:1px solid #ED6A0C;
    padding: 20px 15px;
    margin-bottom: 20px;
  }
  .reg-btn{
    background: #ED6B0D;
    color:#fff;
    width: 80%;
    border-radius: 25px;
    margin: 40px auto 0;
    display: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/views/registers/index.vue